import { render, staticRenderFns } from "./ReportTable.vue?vue&type=template&id=1d2b16e2&scoped=true&"
import script from "./ReportTable.vue?vue&type=script&lang=ts&"
export * from "./ReportTable.vue?vue&type=script&lang=ts&"
import style0 from "./ReportTable.vue?vue&type=style&index=0&id=1d2b16e2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2b16e2",
  null
  
)

export default component.exports